<template>
    <div class="router-view">
        <div class="spacer"></div>
        <div class="spacer"></div>
        <h1 class="h1 text-center">{{ metaData.header }}</h1>
        <div class="spacer"></div>
        <div class="spacer"></div>
        <form class="login-form">
            <div v-if="failed">
                <div class="spacer"></div>
                <v-alert type="error" dense>
                    Неверный пароль или email!
                </v-alert>
                <div class="spacer"></div>
            </div>
            <v-text-field
                    required
                    color="teal lighten-2"
                    label="Введите e-mail"
                    v-model="form.email"
                    :rules="rules.email"
                    @input="validate"
            ></v-text-field>
            <div class="spacer"></div>
            <v-text-field
                    required
                    color="teal lighten-2"
                    label="Введите пароль"
                    v-model="form.password"
                    :rules="rules.password"
                    @input="validate"
                    type="password"
            ></v-text-field>
            <div class="spacer"></div>
            <div class="spacer"></div>
            <div class="text-center">
                <v-btn
                        outlined
                        color="teal"
                        :disabled="!isValid"
                        @click="submit"
                        width="100%"
                >
                    Вход
                </v-btn>
            </div>
        </form>
    </div>
</template>

<script>
    import { MixinMeta, MixinAuth } from "../../mixins"
    import { authService } from "../../services"

    export default {
        name: "Login",
        mixins: [ MixinAuth, MixinMeta ],
        data() {
            return {
                metaUrl: '/login',
                form: {
                    email: '',
                    password: ''
                },
                failed: false,
                isValid: false,
                rules: {
                    email: [
                        v => !!v || 'Необходимо ввести email',
                        v => /.+@.+\..+/.test(v) || 'Некорректный email',
                    ],
                    password: [
                        v => !!v || 'Необходимо ввести пароль'
                    ],
                }
            }
        },
        methods: {
            submit() {
                authService.login(this.form)
                    .then((res) => {
                        this.failed = false;
                        this.login({ ...res.data, loggedIn: true }, '/');
                    })
                    .catch((err) => {
                        this.failed = true;
                        setTimeout(() => {
                            this.failed = false;
                        }, 2000)
                    });
            },
            validate () {
                if(!this.form.email || !this.form.password || !/.+@.+\..+/.test(this.form.email)) {
                    this.isValid = false;
                } else {
                    this.isValid = true;
                }
            },
        },
    }
</script>

<style scoped>
    .login-form {
        max-width: 300px;
        width: 100%;
        margin: auto;
    }
</style>
